<template>
  <v-app id="inspire">
    <v-navigation-drawer app clipped v-model="navBar">
      <v-list dense>
        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-account</v-icon>
          </v-list-item-icon>

          <v-list-item-title>{{ $store.state.user.nombre }}</v-list-item-title>

          <v-spacer></v-spacer>


          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon color="white" v-on="on" v-bind="attrs" @click="showForm = true">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar usuario</span>
          </v-tooltip>
        </v-list-item>
      </v-list>

      <v-divider />
      <v-list>
        <v-list-item :to="`/${$t('rutas.notifications')}`" link>
          <v-list-item-icon>
            <v-icon>mdi-bell</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t("notifications") }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="`/${$t('rutas.ordenes_compra')}`" link>
          <v-list-item-icon>
            <v-icon>mdi-currency-usd</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t("ordenes_compra") }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="`/${$t('rutas.documentacion')}`" link>
          <v-list-item-icon>
            <v-icon>mdi-file-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t("documentacion") }}</v-list-item-title>
        </v-list-item>

        <v-list-item :to="`/${$t('rutas.pagos_pendientes')}`" link>
          <v-list-item-icon>
            <v-icon>mdi-cash</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t("pagos_pendientes") }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app clipped-left>
      <v-app-bar-nav-icon @click.stop="navBar = !navBar"></v-app-bar-nav-icon>
      <v-spacer />
      <v-toolbar-title>
        <h3>{{ $t("proveedores") }}</h3>
      </v-toolbar-title>
      <v-spacer />
      <v-menu left bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item link @click="logout">
            <v-list-item-icon>
              <v-icon>mdi-power</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{
              $t("cerrar_sesion")
            }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-container>
      <router-view></router-view>


      <GeneralUserForm v-model="showForm" @save="handleProfileSave" />


    </v-container>
  </v-app>
</template>

<script>
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import GeneralUserForm from "../Dashboard/GeneralUserForm.vue";
export default {
  data() {
    return {
      username: "",
      navBar: null,
      showForm: false
    };
  },
  components: {
    GeneralUserForm
  },
  methods: {
    handleProfileSave(payload) {
      this.$store.commit("updateUser", payload);
    },
    async logout() {
      Swal.fire({
        title: this.$t("mensaje_cierre_sesion"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("aceptar"),
        cancelButtonText: this.$t("cancelar"),
      }).then((result) => {
        if (result.value) {
          this.openLoader();
          window.setTimeout(async () => {
            if (window.localStorage.token) {
              await fetch(`${this.$store.state.proveedorUrl}logout`, {
                method: "POST",
                headers: {
                  "X-Requested-With": "XMLHttpRequest",
                  Authorization: `Bearer ${window.localStorage.token}`
                }
              }).catch(() => {});
            }

            this.clearSession();
            window.location = `/${this.$t("rutas.inicio_sesion")}`;
            this.closeLoader();
          }, 200);
        }
      });
    },
  },
  async created() {
    if (!this.$store.state.user || !this.$store.state.user.id) {
      this.clearSession();
      this.redirectToLogin();
      return;
    }

    const userURL = `${this.$store.state.proveedorUrl}${this.$store.state.user.id}`;
    const { data, success } = await this.sendRequest(userURL);
    if (!success) return;

    this.$store.state.user = data;
    window.localStorage.user = JSON.stringify(data);
  },
};
</script>
